import "./home.css";
//import { IAppUser } from "../../models/IAppUser";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../Services/AppInsightService";
import { useAuth } from "../../auth/AuthContext";

interface IProps {
    // userAuthenticated: boolean
    // loginCallback: (user: IAppUser) => void;
    // logoutCallback: () => void;
}

//export const HomeContent: React.FC<IProps> = ({ userAuthenticated, loginCallback, logoutCallback }) => {
export const HomeContent: React.FC<IProps> = () => {
    const { user, userAuthenticated } = useAuth();

    return (
        <div className="Home">
            <h1>Welcome Brave Adventurer{userAuthenticated && user.Name ? `, ${user.Name}` : ""}.</h1>

            <div style={{width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                <div style={{width: "70%"}}>
                    This is an RPG Adventure initially based on lessons from ScottLilly.com -- Build a C#/WPF RPG, but highly customized.<br /><br />

                    This ver is my idea's of how things could be better setup instead, and using .NET Core instead of .NET Framework for the backend, and React for the frontend UI.<br />
                    As mentioned, for this ver I decided to put what I have learned about React to use, so the UI is getting an upgrade over the initial WPF version I started/did (while I learn more at the same time).<br />
                    I think this will also allow the UI to visually be more inline with my vision of what it should look like, and have features I think are required.<br /><br />

                    My goal / plan is to initially create a basic D20 / D&D / Nethack / RPG dungeon crawl, based 
                    on <a href="https://www.nethack.org/" target="_blank" rel="noopener noreferrer">Nethack</a> (<a href="https://en.wikipedia.org/wiki/NetHack" target="_blank" rel="noopener noreferrer">wiki</a>)
                    and other computer RPG games I played growing up 
                    like <a href="https://en.wikipedia.org/wiki/The_Bard%27s_Tale_(2004_video_game)" target="_blank" rel="noopener noreferrer">The Bards Tale</a>
                    , <a href="https://en.wikipedia.org/wiki/Curse_of_the_Azure_Bonds" target="_blank" rel="noopener noreferrer">Curse of the Azure Bonds</a>, 
                    or <a href="https://en.wikipedia.org/wiki/Shining_in_the_Darkness" target="_blank" rel="noopener noreferrer">Shining in the Darkness</a>, based roughly on the D&D 5e (2014) rule set. 
                    Then hopefully expand things into a world with dungeons and castles and towns / cities for any brave Adventurer to explore. 
                    Not currently being in an 
                    active <a href="https://en.wikipedia.org/wiki/Dungeons_%26_Dragons" target="_blank" rel="noopener noreferrer">D&D</a> or 
                    even <a href="https://en.wikipedia.org/wiki/Shadowrun" target="_blank" rel="noopener noreferrer">Shadowrun</a> table top group, at the moment, I'm also hoping this can/will scratch my itch for some RPG table top gaming as well.
                </div>
                <br />
            </div><br />
            {!userAuthenticated &&
                <div>
                    Login to start playing.<br />
                    A login name of "Guest", with an email of "guest@guest.com", can freely play.<br /><br />
                </div>
            }
            {/* <div style={{ position: "absolute", left: "46vw" }}>
                <Login user={ user } userAuthenticated={ userAuthenticated } loginCallback={ (ret: IAppUser) => useAuth().login(ret) } logoutCallback={ () => useAuth().logout()} />
            </div> */}
            <br />
            {/* {userAuthenticated && <CharList />} */}
        </div>
    );
}

export default withAITracking(reactPlugin, HomeContent);
